export default __webpack_public_path__ + "static/nmn-award-2023-white-496cf5548adef68df6e75f4110600171.svg";